import styled, { keyframes } from 'styled-components';

// Slide-up 애니메이션
const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const CookieBannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 16px 24px;
  background: ${({ theme }) => (theme?.isDarkMode ? '#1a1a1a' : '#2c2c2c')};
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  animation: ${slideUp} 0.4s ease-out;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;

export const CookieBannerContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const CookieTextSection = styled.div`
  flex: 1;
  color: #ffffff;
`;

export const CookieTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const CookieMessage = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #d1d5db;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

export const CookieActionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 280px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const CookieButtonGroup = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const CookieButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  ${({ $variant }) =>
    $variant === 'primary'
      ? `
    background: #F0B90B;
    color: #000;

    &:hover {
      background: #FCD535;
      transform: translateY(-1px);
      box-shadow: 0 3px 10px rgba(240, 185, 11, 0.3);
    }
  `
      : `
    background: transparent;
    color: #F0B90B;
    border: 2px solid #F0B90B;

    &:hover {
      background: rgba(240, 185, 11, 0.1);
      border-color: #FCD535;
    }
  `}

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 9px 16px;
    font-size: 12px;
  }
`;

export const CookieManageLink = styled.button`
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  padding: 2px 0;
  text-decoration: underline;
  transition: color 0.2s ease;

  &:hover {
    color: #F0B90B;
  }

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;
